import React, { useContext, FormEvent } from 'react';
import { Card, TextField, Button } from '@material-ui/core';
import { MainLogo } from 'src/components/MainLogo';
import { useHistory } from 'react-router-dom';
import { NotLoggedInLayout } from 'src/components/NotLoggedInLayout';
import { ResetPasswordContext } from 'src/model/ResetPasswordContext';
import { CustomAlert } from 'src/components/CustomAlert';

export const ActivateAccountPage: React.FC<{}> = () => {
  const resetPasswordModel = useContext(ResetPasswordContext);
  const history = useHistory();
  const codeFromLink = window.location.search.replace('?code=', '') || '';
  const [isErrorOn, setErrorOn] = React.useState(false);
  const [isSuccessOn, setSuccessOn] = React.useState(false);
  const [errorText, setErrorText] = React.useState('');
  const [isPasswordMismatch, setPasswordMismatch] = React.useState(false);
  const [isPasswordBad, setPasswordBad] = React.useState(false);

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();

    const code = e.target['code'].value;
    const password = e.target['password'].value;
    const repeat = e.target['repeat'].value;

    if (password.length < 6) {
      setPasswordBad(true);
      return;
    } else {
      setPasswordBad(false);
    }

    if (password !== repeat) {
      setPasswordMismatch(true);
      return;
    } else {
      setPasswordMismatch(false);
    }
    
    resetPasswordModel.handleActivateUser(
      code,
      password,
      () => {
        setSuccessOn(true);
        history.push("/login");
      },
      (e) => {
        setErrorOn(true)
        setErrorText(e.error)
      }
    );
  };

  const noAutocompleteProps = {
    autoComplete: 'new-password',
  }

  return (
    <NotLoggedInLayout>
      <Card style={{ padding: '38px' }}>
        <MainLogo />
        <form className='loginForm' noValidate onSubmit={handleSubmit}>
          <h3>Activate your account</h3>
          <div>Please check your inbox and click the link sent to you or enter the security code manually</div>
          <div>
            <TextField fullWidth id='code' inputProps={noAutocompleteProps} label='Security code (from e-mail)' defaultValue={codeFromLink} onInput={() => setErrorOn(false)} disabled/>
            <CustomAlert isOpen={isErrorOn} severity='error' title="Can't activate account">
              {errorText||'Please check your security code!'}
            </CustomAlert>
            <CustomAlert isOpen={isSuccessOn} severity='success' title="Account activated">
              {errorText||'You can now login !'}
            </CustomAlert>
          </div>
          <div>
            <TextField fullWidth id='password' inputProps={noAutocompleteProps} type='password' label='Password' onInput={() => setPasswordBad(false)} />
            <CustomAlert isOpen={isPasswordBad} severity='error' title="Weak password">
              Please make sure your passwords is at least 6 symbols long.
            </CustomAlert>
          </div>
          <div>
            <TextField fullWidth id='repeat' type='password' inputProps={noAutocompleteProps} label='Repeat password' onInput={() => setPasswordMismatch(false)} />
            <CustomAlert isOpen={isPasswordMismatch} severity='error' title="Passwords mismatch">
              Please make sure your passwords match.
            </CustomAlert>
          </div>
          <div className='buttons'>
            <div>
              <Button fullWidth variant='contained' color='primary' type='submit'>
                Activate account
              </Button>
            </div>
          </div>
        </form>
      </Card>
    </NotLoggedInLayout>
  );
};
